/**
 * Who may open Slide Creator during its internal alpha (M4S-5702,
 * docs/pdlc/slide-creator-alpha.md). Pure, so the browser and the server read
 * the same rule.
 *
 * One rule: an internal viewer who holds `slide-creator-alpha`. The nav row and
 * the Home tile express it as `internalHref` + `internalRequiresFlag`
 * (`@nav/access/resolve-access.ts`), and `alpha-access.test.ts` holds them to
 * this function. The page, the My Surveys badge and every `/api/slide-creation`
 * route call it directly.
 *
 * Being internal is part of the rule, not a default of the flag: an org override
 * or `enabledExternal` switched on by mistake opens nothing for a client.
 */

/** Per-user overrides for the alpha testers. Absent or unreadable is off. */
export const SLIDE_CREATOR_ALPHA_FLAG = 'slide-creator-alpha';

export function canOpenSlideCreator(viewer: {
    isInternal: boolean | undefined;
    hasAlphaFlag: boolean;
}): boolean {
    return viewer.isInternal === true && viewer.hasAlphaFlag;
}
